import { Button, Flex, Link, Text } from '@adobe/react-spectrum';
import Alert from '@spectrum-icons/workflow/Alert';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: rgb(255, 236, 207);
  padding: 18px 16px 12px;
  margin-top: ${
    /** @param {{$marginTop: 'string' | 'number'}} props */
    (props) => props.$marginTop
  };
  margin-bottom: ${(props) => props.$marginBottom};
  align-self: center;
`;

const EU_DIGITAL_SERVICES_ACT_URL = 'https://www.adobe.com/go/eu_digital_services_act';

const NotAvailableInEUBanner = ({ marginTop = '32px', marginBottom = '40px' }) => {
  return (
    <Container $marginTop={marginTop} $marginBottom={marginBottom} role="alert">
      <Flex gap="size-100">
        <Alert aria-label="" color="notice" />
        <Flex direction="column" flex="1">
          <Text>
            <strong>This listing is not currently available in the EU</strong>
          </Text>
          <Text marginBottom="size-100">
            This developer has not yet submitted the trader information required by the{' '}
            <Link href={EU_DIGITAL_SERVICES_ACT_URL} variant="secondary" target="_blank" rel="noopener noreferrer">
              EU Digital Services Act
            </Link>
            .
          </Text>
          <Button
            alignSelf="end"
            variant="primary"
            onPress={() => window.open(EU_DIGITAL_SERVICES_ACT_URL, '_blank', 'noopener,noreferrer')}
          >
            Learn more
          </Button>
        </Flex>
      </Flex>
    </Container>
  );
};

export default NotAvailableInEUBanner;
